import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { projectsAPI as API } from "../../apis/projects";
import { RootState } from "../store";

export const loadProjects = createAsyncThunk(
  "projects/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { projects } = getState() as RootState;
      if (projects.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Project>();
interface State extends EntityState<Project> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: State = {
  ...itemsAdapter.getInitialState(),
  status: "idle",
};

const slice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadProjects.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadProjects.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadProjects.fulfilled, (state, action) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, action.payload.data);
      });
  },
});

export default slice.reducer;
